import React from "react";

const Loader = ({ size }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      preserveAspectRatio="xMidYMid"
      viewBox="0 0 100 100"
    >
      <rect width="7" height="17" x="46.5" y="21.5" fill="#eff1fc" rx="3.5" ry="3.91">
        <animate
          attributeName="opacity"
          begin="-0.875s"
          dur="1s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        />
      </rect>

      <rect
        width="7"
        height="17"
        x="46.5"
        y="21.5"
        fill="#dce0fc"
        rx="3.5"
        ry="3.91"
        transform="rotate(45 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.75s"
          dur="1s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        />
      </rect>

      <rect
        width="7"
        height="17"
        x="46.5"
        y="21.5"
        fill="#abb4f4"
        rx="3.5"
        ry="3.91"
        transform="rotate(90 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.625s"
          dur="1s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        />
      </rect>
      <rect
        width="7"
        height="17"
        x="46.5"
        y="21.5"
        fill="#7a89f4"
        rx="3.5"
        ry="3.91"
        transform="rotate(135 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.5s"
          dur="1s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        />
      </rect>

      <rect
        width="7"
        height="17"
        x="46.5"
        y="21.5"
        fill="#4056f4"
        rx="3.5"
        ry="3.91"
        transform="rotate(180 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.375s"
          dur="1s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        />
      </rect>

      <rect
        width="7"
        height="17"
        x="46.5"
        y="21.5"
        fill="#1e22ff"
        rx="3.5"
        ry="3.91"
        transform="rotate(225 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.25s"
          dur="1s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        />
      </rect>

      <rect
        width="7"
        height="17"
        x="46.5"
        y="21.5"
        fill="#181bcc"
        rx="3.5"
        ry="3.91"
        transform="rotate(270 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="-0.125s"
          dur="1s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        />
      </rect>

      <rect
        width="7"
        height="17"
        x="46.5"
        y="21.5"
        fill="#121499"
        rx="3.5"
        ry="3.91"
        transform="rotate(315 50 50)"
      >
        <animate
          attributeName="opacity"
          begin="0s"
          dur="1s"
          keyTimes="0;1"
          repeatCount="indefinite"
          values="1;0"
        />
      </rect>
    </svg>
  );
};

export default Loader;
